import React, { useEffect, useState, Fragment, useRef } from 'react';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf'
import { CSVLink, CSVDownload } from "react-csv";
import { TableEmployeeTaskDetails } from '../../Common/Table/tableContent';
import _ from 'lodash';

export const EmployeeTaskDetailsListing = ({ employeeTaskDetailsFilteringData, searchData, isDataAvilable }) => {

    const componentRef = useRef();

    const [data, setData] = useState([]);
    const [csvData, setCsvData] = useState([]);

    const contentRowNames = ["firstName", "cardNumber", "progress", "taskName"]

    useEffect(() => {
        if (employeeTaskDetailsFilteringData.length > 0) {
            setEmployeeTaskDetailsFilteringData();
            generateCSVData(employeeTaskDetailsFilteringData);
        }
    }, [employeeTaskDetailsFilteringData]);

    async function setEmployeeTaskDetailsFilteringData() {
        destroyDataTable();
        await setData(employeeTaskDetailsFilteringData);
        createDataTable();
    }

    function generateCSVData(data) {
        var newCsvArray = []

        for (const record of data) {
            var newRecord = {
                CardNumber: record.cardNumber,
                FirstName: record.firstName,
                Progress: record.progress,
                TaskName: record.taskName
            }
            newCsvArray.push(newRecord);
        }

        setCsvData(newCsvArray);
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            {!isDataAvilable ? null :
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <hr />
                                <div className="table-responsive row-top-gap">
                                    <table id="example" className="display dataTable no-footer">
                                        <thead>
                                            <tr>
                                                <th>Employee Name</th>
                                                <th>Card Number</th>
                                                <th>Progress</th>
                                                <th>Task Name</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <TableEmployeeTaskDetails
                                                data={data}
                                                contentRowNames={contentRowNames}
                                                hasEdit={false}
                                            />
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pt-2">
                        <ReactToPrint
                            trigger={() => <input
                                type="button"
                                className="btn btn-primary pull-right ml-2"
                                value="Create PDF"
                            />}
                            content={() => componentRef.current}
                        />
                        <div hidden={true}>
                            <CreatePdf ref={componentRef} data={data}
                                rowNames={contentRowNames} searchData={searchData} />
                        </div>
                        <CSVLink
                            data={csvData}
                            filename={"employeetaskdetails.csv"}
                            className="btn btn-primary pull-right"
                            target="_blank"
                        >
                            Excel
                        </CSVLink>
                    </div>
                </div>
            }
        </Fragment>
    )
}


